import { ProductOrigin } from '@leid/api-products'
import { ItemApi } from 'appTypes/items'
import { Item } from 'appTypes/mapper'

export interface CategoryTranslation {
  languageTag: string
  translation: string
  default: boolean
}

export interface Category {
  id: number
  parentCategoryId?: number
  country: string
  imageUrl?: string
  active: boolean
  public: boolean
  createdAt: Date
  updatedAt: Date
  nameTranslations: CategoryTranslation[]
  type: string
  orderWeight?: number
  subCategory?: Category[]
}

export function formatCategories(data: Category[]): Category[] {
  const categoryMap = new Map<number, Category>()

  data.forEach((category) => {
    categoryMap.set(category.id, { ...category, subCategory: [] })
  })

  const topLevelCategories: Category[] = []
  categoryMap.forEach((category) => {
    const parentId = category.parentCategoryId
    if (parentId === undefined) {
      topLevelCategories.push(category)
    } else {
      const parentCategory = categoryMap.get(parentId)
      if (parentCategory) {
        parentCategory.subCategory!.push(category)
      }
    }
  })

  const sortAndClean = (categories: Category[]) => {
    categories.sort((a, b) => (a.orderWeight ?? Infinity) - (b.orderWeight ?? Infinity))

    categories.forEach((category) => {
      if (category.subCategory && category.subCategory.length > 0) {
        sortAndClean(category.subCategory)
      } else {
        delete category.subCategory
      }
    })
  }

  sortAndClean(topLevelCategories)

  return topLevelCategories
}

export const getBackgroundImageUrl = (mediaUrl?: string): string => {
  if (!mediaUrl) return 'none'

  const isLocal = window.location.hostname === 'localhost'
  const finalUrl = isLocal ? `https://leid.no${mediaUrl}` : mediaUrl

  return `url(${finalUrl})`
}

export const calculateLengthOfString = (string: string): number => {
  return string.length
}

export const isLeidProduct = (product: ItemApi | Item) => {
  return product.productOrigin === ProductOrigin.LEID_SMART || product.productOrigin === ProductOrigin.FRANCHISEE
}
